import apiFetch from '../../apiFetch'

export default function (organizedUnitId, token) {
  return apiFetch({ endPoint: 'Dossier/Purchase/VOCompanies?organizedUnitId=' + organizedUnitId, method: 'GET', token: token })
}
